import Api from "./api.js";

export default {
   searchAdvanced(formData) {
      return Api().post('/umbraco/surface/api/searchadvanced', formData);
   },
   searchCommon(url, formData) {
      return Api().post(url, formData);
   },
   searchForPrinting(formData) {
      return Api().post('/umbraco/surface/api/searchforprint', formData);
   }
};


// WEBPACK FOOTER //
// ./src/api/searchApi.js